export default "__VITE_ASSET__D2mhCN7n__"